import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { getDoc, doc, collection, DocumentSnapshot } from "firebase/firestore"
import { db } from "../firebase"
import { FormProps, StepForm } from "./lib/StepForm"
import { Box, Typography } from "@mui/material"

const ArrivalRegistration = () => {
  const urlParams = useParams<{ individualId: string }>()
  const [values, setValues] = useState<Record<string, string|number>>({})
  const [forms, setForms] = useState<Array<FormProps>>([])
  const navigate = useNavigate()

  useEffect(() => {
    getDoc(doc(collection(db, 'forms'), 'individual')).then((_: DocumentSnapshot) => {
      _.exists() && setForms(_.data().conf.filter((form: FormProps) => form.isArrivalElements))
    })
    const storageValues = sessionStorage.getItem('individual')
    if (storageValues) {
      setValues(JSON.parse(storageValues))
    }
    else {
      getDoc(doc(collection(db, 'individuals'), urlParams.individualId)).then((_: DocumentSnapshot) => {
        const data = _.data()
        if (data && data.status === "arrived") {
          setValues(data)
        }
        else {
          window.alert('既に施設到着情報は登録済みです')
          navigate('/')
        }
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onSave = (values: Record<string, string | number>) => {
    setValues(values)
    sessionStorage.setItem('individual', JSON.stringify(values))
    navigate(`/individuals/${urlParams.individualId}/arrival/confirm`)
  }

  return (
    <Box display="flex-col">
      <Typography>捕獲個体到着登録</Typography>
      <StepForm values={values} forms={forms} onSave={onSave} />
    </Box>

  )
}

export default ArrivalRegistration
